import React from 'react';
import { Code2, Github, Twitter, Linkedin, Mail } from 'lucide-react';
import { Separator } from './ui/separator';

export const Footer = () => {
  return (
    <footer className="bg-secondary text-secondary-foreground pt-16 pb-8">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center">
                <Code2 className="w-6 h-6 text-primary-foreground" />
              </div>
              <div>
                <h3 className="text-xl font-bold">APIfromSQL</h3>
                <p className="text-xs text-secondary-foreground/70">Intelligence-Powered Code Generator</p>
              </div>
            </div>
            <p className="text-secondary-foreground/80 mb-6 max-w-md leading-relaxed">
              Transform your SQL database schemas into production-ready .NET APIs with Clean Architecture. 
              Accelerate development and maintain code quality effortlessly.
            </p>
            <div className="flex gap-4">
              <a href="https://www.linkedin.com/in/utku-berberoglu/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg bg-secondary-foreground/10 hover:bg-secondary-foreground/20 flex items-center justify-center transition-colors">
                <Github className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/in/utku-berberoglu/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg bg-secondary-foreground/10 hover:bg-secondary-foreground/20 flex items-center justify-center transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/in/utku-berberoglu/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg bg-secondary-foreground/10 hover:bg-secondary-foreground/20 flex items-center justify-center transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/in/utku-berberoglu/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg bg-secondary-foreground/10 hover:bg-secondary-foreground/20 flex items-center justify-center transition-colors">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Product</h4>
            <ul className="space-y-3">
              <li>
                <a href="#features" className="text-secondary-foreground/70 hover:text-secondary-foreground transition-colors">
                  Features
                </a>
              </li>
              <li>
                <a href="#how-it-works" className="text-secondary-foreground/70 hover:text-secondary-foreground transition-colors">
                  How It Works
                </a>
              </li>
              <li>
                <a href="#benefits" className="text-secondary-foreground/70 hover:text-secondary-foreground transition-colors">
                  Benefits
                </a>
              </li>
              <li>
                <a href="#video" className="text-secondary-foreground/70 hover:text-secondary-foreground transition-colors">
                  Tutorial
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Resources</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-secondary-foreground/70 hover:text-secondary-foreground transition-colors">
                  Documentation
                </a>
              </li>
              <li>
                <a href="#" className="text-secondary-foreground/70 hover:text-secondary-foreground transition-colors">
                  API Reference
                </a>
              </li>
              <li>
                <a href="#" className="text-secondary-foreground/70 hover:text-secondary-foreground transition-colors">
                  Support
                </a>
              </li>
              <li>
                <a href="#" className="text-secondary-foreground/70 hover:text-secondary-foreground transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="mb-8 bg-secondary-foreground/20" />

        {/* Bottom */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-secondary-foreground/70">
            © 2024 APIfromSQL. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-sm text-secondary-foreground/70 hover:text-secondary-foreground transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-secondary-foreground/70 hover:text-secondary-foreground transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
